import i18next from "i18next";
import { Settings2FAContext } from "../types/Settings2FAContext";
import { Settings2FAEvent } from "../types/Settings2FAEvent";

export const setDisableSuccessMessageAction = (
  context: Settings2FAContext,
  event: Settings2FAEvent
): Partial<Settings2FAContext> => {
  if (event.type !== "DISABLE_SUCCESS") {
    throw new Error("Invalid event type");
  }
  return {
    message: i18next.t("settings.twoFA.messages.disableSuccess.text"),
    messageTitle: i18next.t("settings.twoFA.messages.disableSuccess.title"),
    messageType: "warn",
  };
};
